import { render, staticRenderFns } from "./draftflow.vue?vue&type=template&id=1ffa01cf&scoped=true&"
import script from "./draftflow.vue?vue&type=script&lang=js&"
export * from "./draftflow.vue?vue&type=script&lang=js&"
import style0 from "./draftflow.vue?vue&type=style&index=0&id=1ffa01cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa01cf",
  null
  
)

export default component.exports